export default __webpack_public_path__ + "static/media/ticketsIcon.f15510aa.svg";